import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="w-full bg-ivory" data-id="element-18" data-mp="1lbisipaq7vqv">
      <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-id="element-19" data-mp="1lc231ky1rhuv">
        <h2 id="faq" className="font-display text-3xl font-semibold leading-tight text-ink sm:text-[2.6rem]" data-id="element-20" data-mp="1gdqqv3ka4v9h">
          Preguntas frecuentes
        </h2>

        <ul className="mt-10 border-t border-blush" data-id="element-21" data-mp="290tidbqjg5q8">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="border-b border-blush" data-id="element-22" data-mp="244cy4smgmbif" data-mpi={i}>
                <h3 data-id="element-23" data-mp="1z25i9ryiebat">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-xl text-ink transition-colors duration-150 ease-smooth hover:text-wine focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wine sm:text-2xl" data-id="element-24" data-mp="1z2xcaycgk0yz">
                    {faq.q}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-wine transition-transform duration-150 ease-smooth ${isOpen ? 'rotate-45' : ''}`} data-id="element-25" data-mp="ki1u7bwohua4" />
                  </button>
                </h3>
                <div id={`faq-panel-${i}`} hidden={!isOpen} className="pb-6 pr-10 font-sans text-base leading-relaxed text-muted" data-id="element-26" data-mp="3t07v0ak8ps7e">
                  {faq.a}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}